import { USER_PERMISSIONS } from 'app/constants';
import { Permissions } from 'app/types/permission';

export function isUserPermittedToIress(permissions?: Array<Permissions>): boolean {
  if (!permissions) {
    return false;
  }
  return permissions.includes(USER_PERMISSIONS.IRESS_SSO as any);
}
